import { DatePicker } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomDropdown from "../../../components/reusable-ui/custom-dropdown";
import SwitchComponent from "../../../components/reusable-ui/switch";
import CustomTextField from "../../../components/reusable-ui/textfield-box";
import { DATE_TIME_FORMATS } from "../../../data/constants";
import { AGGREGATOR_TYPE } from "../../../data/outlet-status-constants";
import { removeSpecialCharacters } from "../../../utils";
import "./style.scss";

interface Props {
  handleInputChange: any;
  data: any;
  errorMsgMap?: any;
  isChangesMade: boolean;
  type?: any;
  isReasonMandatory?: boolean;
}

const OutletToggleForm = (props: Props) => {
  const { data, handleInputChange, errorMsgMap, type="", isReasonMandatory = true } = props;
  const [outletCloseReasonsMap, setOutletCloseReasonsMap] = useState<any>({});
  const { outletCloseReasons } = useSelector((state: any) => ({
    outletCloseReasons: state.businessReducer.businessData.outletCloseReasons,
  }));

  useEffect(() => {
    if (outletCloseReasons?.length) {
      let dataToUpdate = outletCloseReasons.reduce(
        (acc: any, cur: any) => ({
          ...acc,
          [getOutletCloseReasonKey(cur)]: {
            text: cur,
            key: getOutletCloseReasonKey(cur),
          },
        }),
        {}
      );
      setOutletCloseReasonsMap(dataToUpdate);
    }
  }, [outletCloseReasons]);

  const getOutletCloseReasonKey = (closeReason: string) => {
    return closeReason.toLowerCase();
  };

  const handleDateSelection = (dateObj: any) => {
    handleInputChange(dateObj?.toDate(), "endDate");
  };

  const disabledDate = (current: any) => {
    return (
      current &&
      (current < moment().subtract("days", 1) ||
        current > moment().endOf("day").add(7, "d"))
    );
  };

  function checkRenderAutoTurnOnDate() {
    return (
      (type === AGGREGATOR_TYPE.zomato.id ||
        type === AGGREGATOR_TYPE.swiggy.id) &&
      props.isChangesMade &&
      data?.active === 0
    );
  }

  return (
    <>
      <div className="flex items-center mb-[28px]">
        <p className="text-16 font-medium mr-[10px]">Outlet Status</p>
        <p
          className={`text-14 ${
            !!data?.active ? "text-[#0074FB]" : "text-[#C7C7C7]"
          } font-medium w-[30px] mr-[4px]`}
          id="toggle-popup-switch"
        >
          {!!data?.active ? "ON" : "OFF"}
        </p>
        <SwitchComponent
          isChecked={!!data?.active}
          inputProps={{ "aria-label": "ant design" }}
          onSwitchClick={(val: any) => handleInputChange(val ? 1 : 0, "active")}
        />
      </div>
      {checkRenderAutoTurnOnDate() && (
        <>
          <div className="mb-8 text-14 capitalize text-[#656565]">
            Until date
          </div>
          <DatePicker
            popupClassName={"outlet-toggle-time"}
            inputReadOnly
            format={DATE_TIME_FORMATS.dayMonthYearHHMM}
            className={"w-1/2 sm:w-full mb-[20px] rounded-[4px] h-[30px]"}
            getPopupContainer={() =>
              document.getElementById("toggle-popup-switch") || document.body
            }
            showTime
            onOk={handleDateSelection}
            disabledDate={disabledDate}
            onChange={handleDateSelection}
          />
        </>
      )}
      <CustomDropdown
        textBoxLabel="Reason"
        optionsMap={outletCloseReasonsMap}
        isMultiSelect={false}
        placeholder="Select Reason"
        getListItemText={(data: any) => {
          return data.text;
        }}
        parentClass="w-full mb-[6px]"
        dropdownHeading="Reasons"
        searchPlaceholder="Search Reason"
        onSubmit={(val: any) =>
          handleInputChange(outletCloseReasonsMap[val[0]]?.text, "reason")
        }
        uniqueKey="key"
        isMandatory={!data?.active && isReasonMandatory}
        preSelectedValues={getOutletCloseReasonKey(data?.reason) || ""}
        errorMessage={errorMsgMap?.reason || ""}
      ></CustomDropdown>
      <CustomTextField
        textBoxLabel="Reason Note"
        placeholder="Enter Reason Note, Ex - Rush hour"
        regexCheck={removeSpecialCharacters}
        handleChange={(val: string) => handleInputChange(val, "reasonNote")}
        customClass={`min-h-[44px] flex items-center px-16 text-16 font-normal`}
        parentClass={``}
        value={data?.reasonNote}
        rows={1}
        isMandatory={false}
        maxLength={25}
      ></CustomTextField>
    </>
  );
};

export default OutletToggleForm;
